<template>
	<a
		href="#"
		v-b-tooltip
		:title="noticeTooltip"
		:class="['action', { 'turquoise': hasNotice }]"
		@click.prevent="onClick"
	>
		<Icon icon="note"/>
	</a>
</template>

<script>
import Icon from "@/vue/icon/Icon";
import {isEmptyOrNull} from "@/helper/String";
import {mapActions} from "vuex";
import {formatDate} from "@/helper/Date";
import {DateTime} from "luxon";

export default {

	components: {
		Icon,
	},

	props: {
		jobProfileId: {
			type: String,
			required: true,
		},
		type: {
			type: String,
			required: true,
		},
		applicant: {
			type: Object,
			required: false,
		},
		notice: {
			type: Object,
			required: false,
		},
		subTitle: {
			type: String,
			required: false,
		},
	},

	data ()
	{
		return {
			localNotice: this.notice,
		};
	},

	computed: {
		noticeTooltip ()
		{
			if (!this.localNotice)
			{
				return 'Notiz hinzufügen';
			}

			return formatDate(
				DateTime.fromISO(this.localNotice.lastModificationTimeStamp)
			) + "\n\n" + this.localNotice.notice;
		},
		hasNotice ()
		{
			return this.localNotice && !isEmptyOrNull(this.localNotice?.notice || '');
		},
	},

	methods: {
		...mapActions('jobResult/notice', {
			openNoticeFan: 'show',
		}),
		onClick ()
		{
			if (this.calling)
			{
				return;
			}

			this.openNoticeFan({
				jobProfileId: this.jobProfileId,
				applicant: this.applicant,
				notice: this.localNotice?.notice || '',
				type: this.type,
				subTitle: this.subTitle,
				onSave: ({notice}) =>
				{
					if (isEmptyOrNull(notice))
					{
						this.$emit('change', null);
						return;
					}

					this.localNotice = {
						notice,
						lastModificationTimeStamp: DateTime.now().toISO()
					};

					this.$emit('change', this.localNotice);
				}
			});
		},
	},

	watch: {
		notice (v)
		{
			this.localNotice = v;
		}
	}
}
</script>
